var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('charting-box',{attrs:{"title":_vm.$tc('downloadOpen.title')},scopedSlots:_vm._u([{key:"chart",fn:function(ref){
var time = ref.time;
return _c('chart',{attrs:{"type":"bar","height":_vm.height,"data-url":("/admin/api/magazine/charts/downloads-and-opens?issue_id=" + _vm.issueId),"params":time,"options":_vm.options}})}}])})}
var staticRenderFns = []

export { render, staticRenderFns }